import type { IESDocument } from './IESDocument';

export type SearchEntityType = 'mentors' | 'students';

export type SearchMode = 'suggest' | 'full';

/** API hit = IESDocument + WTM extras */
export type SearchHit = IESDocument & {
  slug: string;
  status: string;
  score?: number;
  link?: string;
};

export type SearchListResponse = {
  list: SearchHit[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};

export type SearchParams = {
  q: string;
  type?: SearchEntityType;
  page?: number;
  limit?: number;
  mode?: SearchMode;
};

/** Map SPA locale (en|ua) → ES I18nField key (en|he) */
export function esLang(appLang: string): 'en' | 'he' {
  return appLang?.toLowerCase().startsWith('en') ? 'en' : 'he';
}
